/**
 * UrStudio React Query helpers.
 * Backend scopes by the active artist. Invalidate these keys after workspace sync or an artist switch.
 */

export const URSTUDIO_QUERY_ROOTS = Object.freeze([
  "mixes-library",
  "search-mixes-library",
  "track-stems",
  "search-stems-library",
  "mixAnalysisReport",
]);

/**
 * Cache scope from access payload (null = same as pre-artist / workspace pool).
 * @param {{ artist?: { activeArtistProfileId?: string|null } }|null|undefined} access
 * @returns {string}
 */
export const getUrStudioQueryScope = (access) => {
  const artistId = access?.artist?.activeArtistProfileId;
  return artistId ? String(artistId) : "workspace";
};

/**
 * Invalidate all UrStudio list/detail queries after workspace sync or artist assign.
 * Safe no-op if queryClient missing.
 * @param {import("@tanstack/react-query").QueryClient} [client]
 */
export const invalidateUrStudioQueries = (client) => {
  if (!client?.invalidateQueries) return;
  URSTUDIO_QUERY_ROOTS.forEach((root) => {
    client.invalidateQueries({ queryKey: [root] });
  });
};
